module.exports = __webpack_public_path__ + "img/walkingman.f4f13791.svg";